/**
 * DecisionSheet — the v4 overlay for the Sort menu and the client-report
 * confirmation. On a phone it is a bottom sheet with a grab handle over a
 * scrim; from 768px up the CSS turns it into a centred dialog (`dialog`) or a
 * menu dropping from its trigger (`menu`, which must sit inside a positioned
 * wrapper). Tapping the scrim or pressing Escape closes it.
 */
import type { ComponentChildren } from "preact";
import { useEffect } from "preact/hooks";

export interface DecisionSheetProps {
  onClose: () => void;
  variant: "dialog" | "menu";
  label: string;
  testid?: string;
  children: ComponentChildren;
}

export function DecisionSheet({ onClose, variant, label, testid, children }: DecisionSheetProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <>
      <div class={`decision-sheet-scrim decision-sheet-scrim--${variant}`} onClick={onClose} />
      <div
        class={`decision-sheet decision-sheet--${variant}`}
        role="dialog"
        aria-modal="true"
        aria-label={label}
        data-testid={testid}
      >
        <div class="decision-sheet-handle" aria-hidden="true" />
        {children}
      </div>
    </>
  );
}
